// src/utils/ServiceData.js
import { 
  FiShield, 
  FiShoppingBag, 
  FiBriefcase,
  FiCreditCard,
  FiDollarSign
} from "react-icons/fi";

export const ServiceCards = [  // Note: Capital S to match import
  {
    id: 1,
    title: "Life Insurance",
    description: "Unlimited protection",
    icon: <FiShield />,
    bg: "#e3f2fd",
    textColor: "#0d6efd"
  },
  // ... rest of the service cards
];

export const bankServices = [
  // ... bank services data
];